import React from 'react';
import { CallEvents, CallsManager } from 'controllers/videocall/CallsManager';
import AppendElements from 'components/core/AppendChildren';
import PingMarker from './PingMarker';
import './pingMarkers.css';
import clsx from 'clsx';


function getVideoRect(containerElement, videoWidth, videoHeight)
{
     // calculate video aspect
     let realVideoRect = {x: 0, y: 0, width: videoWidth, height: videoHeight};

     let container = {width: containerElement.clientWidth, height: containerElement.clientHeight};
     let aspect = realVideoRect.width / realVideoRect.height;

     // check wich side overflows container to set the scaled size
     let scaledVideoHeight = container.width / aspect;

     if(scaledVideoHeight > container.height)
     {
         // height is placing the limit
         realVideoRect.width = container.height * aspect;
         realVideoRect.height = container.height;
     }
     else
     {
         // width is placing the limit
         realVideoRect.width = container.width;
         realVideoRect.height = container.width / aspect;
     }
     // apply aspect to container size center

     realVideoRect.x = (container.width * 0.5) - (realVideoRect.width * 0.5);
     realVideoRect.y = (container.height * 0.5) - (realVideoRect.height * 0.5);
     
     return realVideoRect;
}

function containerToPingCoords(containerElement, videoWidth, videoHeight, clickPosition)
{
    let videoRect = getVideoRect(containerElement, videoWidth, videoHeight);
    return {
        x: containerElement.clientWidth ? (clickPosition.x - videoRect.x) / videoRect.width : 0,
        y: containerElement.clientHeight ? (clickPosition.y - videoRect.y) / videoRect.height : 0
    }
}

function pingToContainerCoords(containerElement, videoWidth, videoHeight, pingPosition)
{
    console.log(containerElement);
    
    let videoRect = getVideoRect(containerElement, videoWidth, videoHeight);
    console.log(videoRect);
    console.log({
        x: (pingPosition.x * videoRect.width + videoRect.x) / containerElement.clientWidth,
        y: (pingPosition.y * videoRect.height + videoRect.y) / containerElement.clientHeight
    });
    return {
        x: (pingPosition.x * videoRect.width + videoRect.x) / containerElement.clientWidth,
        y: (pingPosition.y * videoRect.height + videoRect.y) / containerElement.clientHeight
    }
}


function VideoCallPanel({operationName = "", userID, onCallEnded = () => {}})
{

    const [remoteVideoElement, setRemoteVideoElement] = React.useState(CallsManager.remoteVideoElement);
    const [pingPosition, setPingPosition] = React.useState({x:-1,y:-1});
    const [clickPosition, setClickPosition] = React.useState({x:-1,y:-1});
    const [highlightEnabled, setHighlightEnabled] = React.useState(CallsManager.CurrentCall && CallsManager.CurrentCall.highlightEnabled);

    const pingContainerRef = React.useRef();

    React.useEffect(() => {
        function handleMediaChange()
        {
            setRemoteVideoElement(CallsManager.remoteVideoElement);
        }

        function handleHighlight(highlightPoint)
        {
            setPingPosition(pingToContainerCoords(pingContainerRef.current,  remoteVideoElement.getAttribute("data-origWidth"), remoteVideoElement.getAttribute("data-origHeight"), highlightPoint));
        }

        function handleHighlightEnable(value)
        {
            setHighlightEnabled(value);
        }

        CallsManager.on(CallEvents.mediaChanged, handleMediaChange);
        CallsManager.on(CallEvents.highlightReceived, handleHighlight);
        CallsManager.on(CallEvents.highlightEnabled, handleHighlightEnable);
        return () => 
        {
            CallsManager.off(CallEvents.mediaChanged, handleMediaChange);
            CallsManager.off(CallEvents.highlightReceived, handleHighlight);
            CallsManager.off(CallEvents.highlightEnabled, handleHighlightEnable);
        }
    },[remoteVideoElement]);


    const onVideoClick = React.useCallback(function onVideoClick(event)
    {
        if(!highlightEnabled)
        {
            console.log("highlight is disabled!");
            return;
        }

        let clickCoords = {
            x: event.nativeEvent.target.clientWidth ? event.nativeEvent.offsetX / event.nativeEvent.target.clientWidth : 0,
            y: event.nativeEvent.target.clientHeight ? (event.nativeEvent.offsetY / event.nativeEvent.target.clientHeight) : 0
        }

        let pingCoords = containerToPingCoords(event.nativeEvent.target, remoteVideoElement.getAttribute("data-origWidth"), remoteVideoElement.getAttribute("data-origHeight"), {x: event.nativeEvent.offsetX, y: event.nativeEvent.offsetY});

        if(pingCoords.x < 0 || pingCoords.x > 1 || pingCoords.y < 0 || pingCoords.y > 1) return;

        
        if(clickCoords.x === clickPosition.x && clickCoords.y === clickPosition.y)
        {
            clickCoords.x += 0.0001;
        }
        setClickPosition(clickCoords);
        CallsManager.SendHighlight(pingCoords);
    }, [highlightEnabled, clickPosition, remoteVideoElement]);


    return <>
            {CallsManager.remoteVideoElement ? 
            <>
            <AppendElements ref={pingContainerRef} className={clsx("remoteVideo", highlightEnabled ? "highlightEnabled" : "")} htmlElements={remoteVideoElement} onMouseDown={(ev) => {onVideoClick(ev)}}>
                <PingMarker positionX={pingPosition.x} positionY={pingPosition.y} isRemote />
                <PingMarker positionX={clickPosition.x} positionY={clickPosition.y} />
            </AppendElements>
            </>
            :
            <></>
            }
            <div className="videoCallFooter">
            </div>
    </>
}

export default VideoCallPanel;